import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import TruckKanbanService from '../../../services/TruckKanbanService';
import { translate, gerarCSV, formatData } from '../../../utils/util';
import { Input, BackButton, Title, Button, InfiniteScroll } from '../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../utils/handleChangeHooks';
import * as actionsTruckKanban from '../../../actions/truckKanbanAction';

const TransmissionLog = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            truckKanban: true,
            dateStart: "",
            dateEnd: "",
            mviId: ""
        });
    const [transmissions, setTransmissions] = useState([]);
    const [instanceM, setInstanceM] = useState();

    useEffect(() => {
        if (props.transmissions?.items?.length > 0) {
            if (transmissions.length > 0 && currentPage === 0) {
                setTransmissions([...props.transmissions.items]);
            } else {
                setTransmissions((prevState) => ([...prevState, ...props.transmissions.items]));
            }
        } else {
            setTransmissions([]);
        }
        // eslint-disable-next-line
    }, [props?.transmissions?.items]);

    const getTransmissionLogFilter = (report, click) => {
        var currentPageList = click || report ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }

        props.getTransmissions(Object.assign(filter, {
            PageSize: report ? undefined : 25,
            PageIndex: currentPageList
        }), report, (data) => {
            if (report && data.items) {
                gerarCSV("TransmissionLog", data.items);
            }

            if (instanceM) {
                instanceM[1].close();
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getTransmissionLogFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectChange = (item) => {
        props.setTransmission(item);
        props.history.push({
            pathname: `../truckkanban/transmissionLog/details`
        });
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('transmission-log', 'truck-kanban')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('filter', 'physical-confirmation')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field padding col s12">
                                            <Input
                                                defaultValue={filter.dateStart}
                                                type="date"
                                                label={translate('date-start', 'truck-kanban')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field padding col s12">
                                            <Input
                                                defaultValue={filter.dateEnd}
                                                type="date"
                                                label={translate('date-end', 'truck-kanban')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field padding col s12">
                                            <Input
                                                defaultValue={filter?.mviId || ''}
                                                type="text"
                                                placeholder={translate('mviId', 'truck-kanban')}
                                                id="mviId"
                                                name='mviId'
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text="Buscar" onClick={() => getTransmissionLogFilter()} />
                    </div>
                </div>
                <div id="loglist">
                    <InfiniteScroll
                        page={props.transmissions?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        hasMore={currentPage < props.transmissions?.totalPages}
                        data={transmissions.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                onClick={() => {
                                    onSelectChange(item);
                                }}
                            >
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    MVI {item.mvi}
                                </span>
                                {
                                    !item?.success ?
                                        <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)}
                                        </div>
                                        : <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.send')} - {formatData(item?.createdOn || '')}
                                        </div>
                                }
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.truckKanbanReducer.transmissions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, report, callback) => {
            dispatch(TruckKanbanService.getTransmissionPaged(filter, report, callback));
        },
        setTransmission: (item) => {
            dispatch(actionsTruckKanban.selectTransmission(item));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TransmissionLog)));
